import { useState, useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import Paper from "@mui/material/Paper";
import { Box, Typography } from '@mui/material';
import { InputFieldPassword } from "./components/InputFieldPassword";
import { CookieBanner } from "./components/CookieBanner";
import { TextSlider } from "./components/TextSlider";
import backgroundImage from "../../images/Einfahrt_B811.jpeg";
import { useNavigate } from "react-router-dom";
import ChroniclesMain from "../public_pages/chronicles/ChroniclesMain";
import HomePagePublic from "../public_pages/home_page_public/HomePagePublic";

// Login infogig 1.1

import {
    signInWithEmailAndPassword,
    signInWithPopup,
    GoogleAuthProvider,
    OAuthProvider
} from "firebase/auth";

import { auth, db } from "../../firebase";
import { doc, getDoc, query, where, collection, getDocs } from "firebase/firestore";
import { Divider } from "@mui/material";
import Footer from '../../components/footer/Footer';

export const Login = ({ user }) => {
    const navigate = useNavigate();
    const loginHeadingRef = useRef(null);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [signInError, setSignInError] = useState("");
    const [cookieConsent, setCookieConsent] = useState(true);

    const handleSignIn = () => {
        if (!email || !password) return;

        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;
                console.log(user);
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                setSignInError(`Falsches Passwort oder Benutzername. (${error.message})`);
                console.log(errorCode, errorMessage);
            });
    };

    const handleGoogleSignIn = (event) => {
        event.preventDefault(); // Prevent form submission
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider)
            .then((result) => {
                const user = result.user;
                console.log('Google sign-in successful:', user);
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                setSignInError(`Google Anmeldung fehlgeschlagen: ${error.message}`);
                console.log(errorCode, errorMessage);
            });
    };

    const handleAppleSignIn = () => {
        const provider = new OAuthProvider('apple.com');
        provider.addScope('email');
        provider.addScope('name');

        signInWithPopup(auth, provider)
            .then((result) => {
                const user = result.user;
                console.log('Apple sign-in successful:', user);
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                setSignInError(`Apple Anmeldung fehlgeschlagen: ${error.message}`);
                console.log(errorCode, errorMessage);
            });
    };

    const handleEmailChange = (event) => setEmail(event.target.value);
    const handlePasswordChange = (event) => setPassword(event.target.value);
    const handleScrollToLogin = () => {
        if (!loginHeadingRef.current) return;
        loginHeadingRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    const handleNavigate = (path) => () => {
        navigate(path);
    };

    useEffect(() => {
        if (!user) return;

        const redirectByRole = async () => {
            try {
                // try doc by uid first
                const byUidRef = doc(db, "users", user.uid);
                const byUidSnap = await getDoc(byUidRef);

                let role = null;
                if (byUidSnap.exists()) {
                    role = byUidSnap.data()?.role;
                } else {
                    // fallback: find user doc by email
                    const q = query(collection(db, "users"), where("email", "==", user.email));
                    const qs = await getDocs(q);
                    if (!qs.empty) role = qs.docs[0].data()?.role;
                }

                // route by role
                if (String(role).toLowerCase() === "hofdienst") {
                    navigate("/adm/bus_park", { replace: true });
                } else {
                    // default destination after login
                    navigate("/home", { replace: true });
                }
            } catch (err) {
                console.error("Redirect by role failed:", err);
                navigate("/home", { replace: true });
            }
        };

        void redirectByRole();
    }, [user, navigate]);

    if (user) {
        return <Navigate to="/home"></Navigate>;
    }
    return (
        <>
            <section style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                minHeight: '100vh',
                height: 'auto',
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'auto',
                backgroundPosition: 'top left',
                backgroundRepeat: 'repeat',
                backgroundAttachment: 'scroll',
                position: 'relative',
                zIndex: 1,
                paddingTop: '2rem'
            }}>

                {/* Text Slider Component positioned above the Card */}
                <TextSlider />

                <Card
                    sx={{
                        padding: '1rem',
                        mt: 0,
                        mb: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        width: '100%',
                        maxWidth: { xs: 320, sm: '100%' },
                        boxSizing: 'border-box'
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={handleScrollToLogin}
                        sx={{ width: '100%' }}
                    >
                        Login
                    </Button>
                </Card>

                {/*  Section Box with infos about cooperation for infogig app and stops indicator app */}
                <Box>
                    <HomePagePublic />
                </Box>
                <Card sx={{ maxWidth: 445, padding: '1rem', backgroundColor: 'rgba(255, 255, 255, 0.9)' }} >
                    <h2 ref={loginHeadingRef}>Login</h2>
                    <form>
                        <div>
                            <TextField sx={{ m: 1, width: '25ch' }}
                                id="outlined-mail-input"
                                label="E-mail"
                                type="email"
                                autoComplete="email"
                                onChange={handleEmailChange}
                                value={email}
                            />
                        </div>

                        <div>
                            <InputFieldPassword password={password} onChange={handlePasswordChange}
                                id="password" error={signInError}
                            />
                        </div>
                        <Button
                            variant="contained"
                            onClick={handleSignIn}
                            disabled={!cookieConsent}
                            sx={{ m: 1, width: '25ch' }} >Anmelden</Button>

                        {/* Forgot Password Link */}
                        <Box sx={{ textAlign: 'center', mt: 0, mb: 2 }}>
                            <Button
                                variant="text"
                                size="small"
                                onClick={() => navigate('/password-reset')}
                                sx={{
                                    textTransform: 'none',
                                    fontSize: '0.875rem',
                                    color: 'primary.main',
                                    '&:hover': {
                                        backgroundColor: 'transparent',
                                        textDecoration: 'underline'
                                    }
                                }}
                            >
                                Passwort vergessen?
                            </Button>
                        </Box>
                        <Divider sx={{ width: '100%', marginTop: '1rem', marginBottom: '1rem' }} />

                        {/* --- ROW: Google Sign-In and Registration --- */}
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: 2,
                                justifyContent: 'center',
                                alignItems: 'stretch',
                                mb: 2,
                                flexWrap: { xs: 'wrap', sm: 'nowrap' }
                            }}
                        >
                            <Box sx={{
                                flex: 1,
                                minWidth: 160,
                                display: 'flex',
                                alignItems: 'stretch'
                            }}>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    onClick={handleGoogleSignIn}
                                    disabled={!cookieConsent}
                                    sx={{
                                        backgroundColor: '#fff',
                                        color: '#757575',
                                        border: '1px solid #dadce0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        textTransform: 'none',
                                        width: '100%',
                                        height: '100%',
                                        py: 2,
                                        minHeight: 64,
                                        fontSize: { xs: '0.95rem', sm: '1rem' }
                                    }}
                                >
                                    <Box
                                        component="svg"
                                        sx={{ width: 18, height: 18, flexShrink: 0 }}
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            fill="#4285F4"
                                            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                                        />
                                        <path
                                            fill="#34A853"
                                            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                                        />
                                        <path
                                            fill="#FBBC05"
                                            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                                        />
                                        <path
                                            fill="#EA4335"
                                            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                                        />
                                    </Box>
                                    Mit Google anmelden
                                </Button>
                            </Box>
                            <Box
                                sx={{
                                    flex: 1,
                                    minWidth: 160,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1px solid #dadce0',
                                    borderRadius: 1,
                                    backgroundColor: '#fff',
                                    py: 2,
                                    minHeight: 64,
                                    gap: 1
                                }}
                            >
                                <Typography variant="body2" sx={{ textAlign: 'center', mb: 0.5 }}>
                                    Noch kein Konto?
                                </Typography>
                                <Button
                                    variant="outlined"
                                    onClick={() => navigate('/registration')}
                                    sx={{ width: '90%' }}
                                    disabled={!cookieConsent}
                                >
                                    Registrieren
                                </Button>
                            </Box>
                        </Box>
                        {/* --- END ROW --- */}
                    </form>
                    <CookieBanner checked={cookieConsent} onConsentChange={setCookieConsent} />
                    <Divider sx={{ width: '100%', marginTop: '1rem', marginBottom: '1rem' }} />

                    {/* QR Code Card */}
                    <Paper sx={{ padding: '1rem', marginTop: '1rem', textAlign: 'center' }}>
                        <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
                            Direkter Zugang
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 2 }}>
                            Scannen Sie den QR-Code für schnellen Zugriff
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                            <img
                                src="https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=https://infogig.link"
                                alt="QR Code für infogig.link"
                                style={{ border: '2px solid #1976d2', borderRadius: '8px' }}
                            />
                        </Box>
                        <Typography variant="body2" sx={{ color: '#666' }}>
                            infogig.link
                        </Typography>
                    </Paper>

                </Card>

                {/* Chronicles Section */}
                {/* <Box sx={{ mt: 4, width: '90%', maxWidth: '1200px' }}>
                    <Paper elevation={3} sx={{ p: 4, mb: 4, background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)' }}>
                        <Box sx={{ textAlign: 'center', mb: 4, cursor: 'pointer' }} onClick={() => navigate('/chronicles')}>
                            <Typography variant="h3" component="h1" gutterBottom sx={{ color: '#E30613', fontWeight: 'bold', '&:hover': { color: '#b3000f' } }}>
                                Chronik
                            </Typography>
                            <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#666', '&:hover': { color: '#333' } }}>
                                DB Regio Bus Mitte
                            </Typography>
                            <Typography variant="body1" sx={{ maxWidth: '800px', mx: 'auto', fontSize: '1.1rem', lineHeight: 1.6, '&:hover': { color: '#333' } }}>
                                Entdecken Sie die Geschichte unseres Unternehmens - von den ersten Tagen nach der Bahnreform
                                bis hin zu modernen Innovationen im öffentlichen Nahverkehr. Eine Reise durch drei Jahrzehnte
                                Mobilität in der Region Frankfurt am Main.
                            </Typography>
                        </Box>
                    </Paper>
                </Box> */}

                {/* User Manuals Section */}
                {/* <Box sx={{ width: '90%', maxWidth: '1200px' }}>
                    <Paper elevation={3} sx={{ p: 4, mb: 4, background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)' }}>
                        <Box sx={{ textAlign: 'center', mb: 4, cursor: 'pointer' }} onClick={() => navigate('/user_manuals')}>
                            <Typography
                                variant="h3"
                                component="h1"
                                gutterBottom
                                sx={{
                                    color: '#1976d2',
                                    fontWeight: 'bold',
                                    fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }, // Responsive font size
                                    '&:hover': { color: '#125ea2' }
                                }}
                            >
                                Benutzerhandbücher
                            </Typography>
                            <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#666', '&:hover': { color: '#333' } }}>
                                Anleitungen & Informationen
                            </Typography>
                            <Typography variant="body1" sx={{ maxWidth: '800px', mx: 'auto', fontSize: '1.1rem', lineHeight: 1.6, '&:hover': { color: '#333' } }}>
                                Hier finden Sie digitale Handbücher und Anleitungen zu unseren wichtigsten Apps und Tools wie Telematik, EcoApp und LapID.
                                Alles, was Sie für den Einstieg und die Nutzung benötigen, auf einen Blick.
                            </Typography>
                        </Box>
                    </Paper>
                </Box> */}
            </section>
            <Footer />
        </>
    )
}

export default Login;